import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'cp-pwa-banner',
  templateUrl: './pwa-banner.component.html',
  styleUrls: ['./pwa-banner.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PwaBannerComponent {
  @Output() public bannerClosed = new EventEmitter<void>();
  @Output() public downloadClicked = new EventEmitter<void>();

  public onClose(e: MouseEvent | KeyboardEvent): void {
    if (e instanceof KeyboardEvent && e.key !== 'Enter') return;
    e.stopPropagation();

    this.bannerClosed.emit();
  }

  public onDownload(e: MouseEvent | KeyboardEvent): void {
    if (e instanceof KeyboardEvent && e.key !== 'Enter') return;
    e.stopPropagation();

    this.downloadClicked.emit();
  }
}
